module.exports = __webpack_public_path__ + "static/media/SU.6f67e5a2.webp";